
    import { Component, Vue } from 'vue-facing-decorator';
    import { Action, Getter, Mutation } from '@/plugins/vuex-decorators';

    const namespace = 'main';

    @Component
    export default class ModelMenu extends Vue {
        @Getter('getModel', { namespace }) getModel: any;
        @Action('setModel', { namespace }) setModel: any;
        @Getter('getScenarios', { namespace }) getScenarios: any;
        @Getter('getSubModels', { namespace }) getSubModels: any;
        @Getter('getSubModel', { namespace }) getSubModel: any;
        @Action('setSubModel', { namespace }) setSubModel: any;
        @Getter('getModels', { namespace }) getModels: any;
        @Getter('getModelSort', { namespace }) getModelSort!: string;
        @Mutation('SET_MODELSORT', { namespace }) setModelSort: any;
        @Action('downloadFile') downloadFile: any;
        @Action('fetchModelParameters', { namespace }) fetchModelParameters: any;
        @Action('fetchNormalizedScoresFunctions', { namespace }) fetchNormalizedScoresFunctions: any;
        @Action('fetchDrivers', { namespace }) fetchDrivers: any;
        @Action('openNCalcTester', { namespace }) openNCalcTester: any;
        @Action('fetchModelAccess', { namespace }) fetchModelAccess: any;
        @Action('updatePath', { namespace }) updatePath: any;

        private splitModelName(name: string): { title: string; version: string | null } {
            const match = /^(.*)\.(\d+)$/.exec(name ?? '');
            return match
                ? { title: match[1], version: match[2] }
                : { title: name, version: null };
        }

        private get sortByCreatedDesc(): boolean {
            return this.getModelSort === 'createdDesc' || this.getModelSort === 'created';
        }

        private toggleModelSort() {
            this.setModelSort(this.sortByCreatedDesc ? '' : 'createdDesc');
            this.updatePath();
        }

        private get isAuthenticated(): boolean {
            if (this.$msal == null) return true;
            return this.$msal.isAuthenticated;
        }

        private get models(): any {
            return this.getModels;
        }

        private get sortedModels(): any {
            const list = this.getModels ? [...this.getModels] : [];
            if (this.getModelSort === 'createdDesc' || this.getModelSort === 'created') {
                const desc = this.getModelSort === 'createdDesc';
                list.sort((a: any, b: any) => {
                    const ad = a.created ? Date.parse(a.created) : 0;
                    const bd = b.created ? Date.parse(b.created) : 0;
                    return desc ? bd - ad : ad - bd;
                });
            }
            return list;
        }

        private get model(): any {
            const model = this.getModel;
            if (model != null) this.$i18n.locale = model.language;
            return model;
        }

        private set model(value: any) {
            this.setModel(value);
        }

        private get subModels(): any {
            return this.getSubModels;
        }

        private get subModel(): any {
            return this.getSubModel;
        }
        private set subModel(value: any) {
            this.setSubModel(value);
        }
    }
